import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito conocimientos de herboristería para usar este manual?',
    a: 'No. El manual está diseñado específicamente para personas sin experiencia previa. Cada protocolo explica el porqué, el cómo y el cuándo — con ingredientes que ya reconoces de tu cocina.'
  }, {
    q: '¿Esto reemplaza a mi médico?',
    a: 'No. El Manual de Sanación Natural es un complemento a tu cuidado médico, no un reemplazo. Shanon es muy clara en esto: la herboristería y la medicina convencional pueden coexistir y potenciarse mutuamente.'
  }, {
    q: '¿Funcionará para mi condición específica?',
    a: 'El manual cubre las preocupaciones de salud más comunes en adultos de 50+: energía, sueño, digestión, dolor articular, claridad mental e inmunidad. Si tienes condiciones muy específicas, consulta siempre con tu médico.'
  }, {
    q: '¿Cuánto tiempo tarda en llegar el libro?',
    a: 'El envío es por primera clase. Típicamente entre 5-10 días hábiles dependiendo de tu ubicación.'
  }, {
    q: '¿Y si no funciona para mí?',
    a: 'Tienes 7 días de garantía total. Si no sientes ninguna diferencia, recibes tu dinero de regreso. Sin preguntas. Sin complicaciones.'
  }, {
    q: '¿Los ingredientes son difíciles de conseguir?',
    a: 'Absolutamente no. Shanon diseñó cada protocolo usando ingredientes disponibles en supermercados comunes: jengibre, ajo, limón, cúrcuma, manzanilla, canela. Sin importaciones. Sin tiendas especializadas.'
  }];
  return <section className="py-16 px-4 bg-[#FEFCF6]" data-id="element-122">
      <div className="max-w-[700px] mx-auto" data-id="element-123">
        <h2 className="text-3xl font-serif font-bold text-[#2C1810] text-center mb-8" data-id="element-124">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 mb-12" data-id="element-125">
          {faqs.map((faq, i) => <div key={i} className="bg-white border border-[#E8DFD0] rounded-lg overflow-hidden" data-id="element-126">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left font-semibold text-[#2C1810] hover:bg-[#F0F4EC] transition-colors" data-id="element-127">
                {faq.q}
                <ChevronDown className={`w-5 h-5 text-[#2D5A3D] transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-128" />
              </button>
              <AnimatePresence data-id="element-129">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-130">
                    <div className="px-4 pb-4 pt-0 text-[#5C4A3A] leading-relaxed border-t border-[#F0F4EC] mt-2" data-id="element-131">
                      <div className="pt-3" data-id="element-132">{faq.a}</div>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}